export const Button = (props) => <button {...props}>{props.children}</button>;
